module.exports = __webpack_public_path__ + "58fa95f7f5e1c08267c1c8f97403b99d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-small-green.png
// module id = 2753
// module chunks = 0